// Self-contained vanilla-JS wiring for the V1 marketing homepage's
// study-plan modal interactions.
//
// Used in two places (mirroring `animations.js` and
// `marketingAnalytics.js`):
//   1. The React route /www_v1 — IndexPageV1.jsx imports this for its
//      side effect (defining window.__iv1WirePlanModals) and calls the
//      function from a useEffect once the DOM is mounted.
//   2. The static snapshot at lf_fe/public/www/index.html — scripts/
//      save-www-page.sh inlines this file's contents into the saved
//      HTML so pill -> modal clicks work on the deployed marketing
//      page (which has all React scripts stripped).
//
// Keep this file dependency-free and runnable as an inline <script>
// (no imports, no JSX, no ES module exports). Wires via a single
// delegated click listener on `document` so it survives re-renders
// and works against any number of modals on the page.

(function () {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  function findOpenTrigger(start) {
    var node = start;
    while (node && node !== document) {
      if (
        node.getAttribute &&
        node.getAttribute("data-ga-cta") === "plan_modal" &&
        node.getAttribute("data-ga-plan")
      ) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function findAttrAncestor(start, attr) {
    var node = start;
    while (node && node !== document) {
      if (node.getAttribute && node.getAttribute(attr) !== null) return node;
      node = node.parentNode;
    }
    return null;
  }

  function openModal(subject) {
    var modal = document.getElementById(subject + "-details");
    if (modal) modal.style.display = "flex";
  }

  function closeModal(subject) {
    var modal = document.getElementById(subject + "-details");
    if (modal) modal.style.display = "none";
  }

  function toggleTopics(subject, buttonEl) {
    var containers = document.getElementsByClassName(subject + "-topics");
    if (!containers || !containers.length) return;
    var isHidden = containers[0].style.display === "none";
    for (var i = 0; i < containers.length; i += 1) {
      containers[i].style.display = isHidden ? "block" : "none";
    }
    if (buttonEl) {
      buttonEl.textContent = isHidden ? "Hide Details" : "Show Details";
    }
  }

  function onDocumentClick(event) {
    var target = event.target;
    if (!target) return;

    // Close via the modal backdrop. The backdrop is the modal root
    // itself; only fire when the click landed directly on it (not on
    // bubbled-up children).
    var backdrop = findAttrAncestor(target, "data-iv1-modal-root");
    if (backdrop && event.target === backdrop) {
      var rootSubject = backdrop.getAttribute("data-iv1-modal-root");
      if (rootSubject) {
        closeModal(rootSubject);
        return;
      }
    }

    // Close via the explicit close button.
    var closer = findAttrAncestor(target, "data-iv1-modal-close");
    if (closer) {
      var closerSubject = closer.getAttribute("data-iv1-modal-close");
      if (closerSubject) {
        if (event.preventDefault) event.preventDefault();
        closeModal(closerSubject);
        return;
      }
    }

    // Toggle the per-lesson topic disclosures inside an open modal.
    var toggler = findAttrAncestor(target, "data-iv1-modal-toggle-topics");
    if (toggler) {
      var togglerSubject = toggler.getAttribute(
        "data-iv1-modal-toggle-topics",
      );
      if (togglerSubject) {
        if (event.preventDefault) event.preventDefault();
        toggleTopics(togglerSubject, toggler);
        return;
      }
    }

    // Open the modal for the clicked pill.
    var opener = findOpenTrigger(target);
    if (opener) {
      var subject = opener.getAttribute("data-ga-plan");
      if (subject) {
        openModal(subject);
      }
    }
  }

  function run() {
    if (window.__iv1PlanModalsWired) return;
    window.__iv1PlanModalsWired = true;
    document.addEventListener("click", onDocumentClick);
  }

  window.__iv1WirePlanModals = run;
})();
